// extracted by mini-css-extract-plugin
module.exports = {"activityHome":"index_activityHome_3DZp2"};